module.exports = __webpack_public_path__ + "img/2019_m_s_b.d45ad177.jpg";